import React, { Component } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import locales from "../../../_constants/locales";
import StyledButton from "../../../components/StyledButton.jsx";
import CircularProgress from "@material-ui/core/CircularProgress";

import "../styles/ConfirmationSection.css";

class ConfirmationSection extends Component {
    render() {
        return (
            <div className="section confirmation-section">
                <div className="section-header">
                    <div className="layout horizontal center title-row">
                        <h2 className="title">{locales[this.props.language.code].TICKET_CONFIRMATION.CONFIRMATION.TITLE}</h2>
                    </div>
                </div>
                <div className="section-body">
                    <div className="flex layout vertical confirmation-section-box">
                        <div>
                            <div className="flex layout vertical customer-message">
                                <p>{locales[this.props.language.code].TICKET_CONFIRMATION.CONFIRMATION.CUSTOMER_MESSAGE.TITLE}</p>
                                <p>{locales[this.props.language.code].TICKET_CONFIRMATION.CONFIRMATION.CUSTOMER_MESSAGE.STEPS}</p>
                                <p>{locales[this.props.language.code].TICKET_CONFIRMATION.CONFIRMATION.CUSTOMER_MESSAGE.FOOTER}</p>
                            </div>
                            <div className="flex layout horizontal">
                                <FormControlLabel
                                    className="custom-form-control-label"
                                    control={
                                        <Checkbox
                                            checked={this.props.isConfirmCheckboxChecked}
                                            onChange={this.props.handleChange.bind(this)}
                                            name="isConfirmCheckboxChecked"
                                            color="primary"
                                        />
                                    }
                                    label={locales[this.props.language.code].TICKET_CONFIRMATION.CONFIRMATION.CONFIRM_CHECKBOX.LABEL}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-footer">
                    <div className="flex layout horizontal end-justified confirmation-footer-box">
                        <StyledButton
                            id="submit-button-id"
                            variant="contained"
                            disabled={this.props.submitButtonDisabled}
                            onClick={this.props.handleSubmitClick.bind(this)}
                        >
                            {locales[this.props.language.code].BUTTON.SUBMIT.LABEL}
                            {this.props.ticketUpdating && <CircularProgress className="button-progress" size={16} thickness={4} />}
                        </StyledButton>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmationSection;
